<template>
  <div>
    <helpers-section-header class="mt-6 mb-8"> WhaleML Signal Rules </helpers-section-header>

    <v-checkbox v-model="criteria.long_enabled" label="Allow Long Signals" hide-details />
    <v-checkbox v-model="criteria.short_enabled" label="Allow Short Signals" hide-details />

    <helpers-section-sub-header class="mt-6 mb-2"> Signal Evaluation: </helpers-section-sub-header>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="criteria.number_of_days_to_evaluate"
          label="Days to evaluate"
          suffix="days"
          hint="Number of days after filing released (plus trading delay) to continue to evaluate as a buy"
          persistent-hint
          style="max-width: 250px"
        />
      </v-col>
    </v-row>

    <v-table class="my-8">
      <thead>
        <tr>
          <th>WhaleML Family</th>
          <th colspan="2" class="text-center">Long Min/Max Score</th>
          <th colspan="2" class="text-center">Short Min/Max Score</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="m in criteria.predictions" :key="m.whale_ml_type_id">
          <td class="py-4">
            <v-checkbox
              v-model="m.enabled"
              :label="m.name"
              color="primary"
              hide-details
              class="mt-0"
            />
          </td>

          <template v-if="m.whale_ml_type_id == 7">
            <td colspan="2">
              <v-checkbox v-model="m.long.enabled" label="Long Enabled" hide-details class="mt-0" />
            </td>
            <td colspan="2">
              <v-checkbox
                v-model="m.short.enabled"
                label="Short Enabled"
                hide-details
                class="mt-0"
              />
            </td>
          </template>

          <template v-else>
            <td>
              <v-select
                v-model="m.long.min"
                :items="prediction_scores"
                item-title="description"
                label="Min Score"
                hide-details
                class="mt-0"
              />
            </td>
            <td>
              <v-select
                v-model="m.long.max"
                :items="prediction_scores"
                item-title="description"
                label="Max Score"
                hide-details
                class="mt-0"
              />
            </td>
            <td>
              <v-select
                v-model="m.short.min"
                :items="prediction_scores"
                item-title="description"
                label="Min Score"
                hide-details
                class="mt-0"
              />
            </td>
            <td>
              <v-select
                v-model="m.short.max"
                :items="prediction_scores"
                item-title="description"
                label="Max Score"
                hide-details
                class="mt-0"
              />
            </td>
          </template>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script>
// Modules
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { mapWritableState } from 'pinia'
export default {
  data() {
    return {
      dialog: false,
      prediction_scores: [
        { description: 'Strong Outperform', value: 3 },
        { description: 'Outperform', value: 2 },
        { description: 'Neutral+', value: 1 },
        { description: 'Strong Underperform', value: -3 },
        { description: 'Underperform', value: -2 },
        { description: 'Neutral-', value: -1 }
      ]
    }
  },
  computed: {
    ...mapWritableState(useAppStore, ['whaleTraderCriteria']),
    criteria() {
      return this.whaleTraderCriteria.signals.whaleml_signal
    },
    appcriteria() {
      return this.whaleTraderCriteria
    },
    enabled() {
      return this.whaleTraderCriteria.signals.whaleml_signal.enabled
    }
    /*...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.whaleml_signal',
      enabled: 'app.whaleTraderCriteria.signals.whaleml_signal.enabled',
      signalView: 'app.signalView'
    })*/
  }
}
</script>
